import { Vector2, Vector3, Raycaster } from 'three'

export default {
  install (Vue, options) {
    let device = {}

    const raycaster = new Raycaster()

    device.width = 0
    device.height = 0
    device.scroll = { left: 0, top: 0 }
    device.pixelRatio = window.devicePixelRatio

    device.isTouch = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)
    device.isIpad = navigator.userAgent.match(/.*(iPad).*/)
    device.isIphone = navigator.userAgent.match(/.*(iPhone).*/)
    device.isAndroid = navigator.userAgent.match(/.*(Android).*/)
    device.isFirefox = navigator.userAgent.match(/.*((f|F)irefox).*/)
    device.isChrome = navigator.userAgent.match(/.*(Chrome).*/)
    device.isSafari = navigator.userAgent.match(/.*(Safari).*/) && !device.isChrome
    /* eslint-disable */
    device.isTrident = navigator.userAgent.match(/Trident.*rv\:11\./)
    device.isEdge = navigator.userAgent.match(/.*(Edge).*/)
    device.isMSIE = navigator.userAgent.match(/.*(MSIE ).*/)

    device.pointer = !!window.navigator.pointerEnabled
    device.msPointer = !!window.navigator.msPointerEnabled
    device.pointerdown = device.isTouch ? 'touchstart' : (device.pointer ? 'pointerdown' : (device.msPointer ? 'MSPointerDown' : 'mousedown'))
    device.pointerup = device.isTouch ? 'touchend' : (device.pointer ? 'pointerup' : (device.msPointer ? 'MSPointerUp' : 'mouseup'))
    device.pointermove = device.isTouch ? 'touchmove' : (device.pointer ? 'pointermove' : (device.msPointer ? 'MSPointerMove' : 'mousemove'))
    device.pointerenter = device.isTouch ? 'touchstart' : (device.pointer ? 'pointerenter' : (device.msPointer ? 'mouseenter' : 'mouseenter'))
    device.pointerleave = device.isTouch ? 'touchend' : (device.pointer ? 'pointerleave' : (device.msPointer ? 'mouseout' : 'mouseout'))
    device.pointerover = device.isTouch ? 'touchstart' : (device.pointer ? 'pointerover' : (device.msPointer ? 'mouseover' : 'mouseover'))
    device.pointerout = device.isTouch ? 'touchend' : (device.pointer ? 'pointerout' : (device.msPointer ? 'mouseout' : 'mouseout'))
    device.click = 'click'

    device._onResize = () => {
      device.width = window.innerWidth
      device.height = window.innerHeight
      device.orientation = window.matchMedia("(orientation: portrait)").matches ? 'portrait' : 'landscape'
      device.pixelRatio = window.devicePixelRatio
    }

    device._onScroll = () => {
      const doc = document.documentElement

      device.scroll.left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0)
      device.scroll.top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
    }

    device.getPointerPosition = event => {
      let clientY = event.clientY
      let clientX = event.clientX

      if (this.isTouch) {
        clientY = event.touches[0].clientY
        clientX = event.touches[0].clientX
      }

      return {
        x: clientX,
        y: clientY
      }
    }

    device.getRaycastedPosition = (event, mesh, camera) => {
      let pos = device.getPointerPosition(event)
      pos = new Vector2(( pos.x / device.width ) * 2 - 1, - ( pos.y / device.height ) * 2 + 1)
      raycaster.setFromCamera( pos, camera )
      let intersects = []
      if (Array.isArray(mesh)) {
        intersects = raycaster.intersectObjects( mesh, true )
      }
      else {
        intersects = raycaster.intersectObject( mesh, true )
      }

      if(intersects.length >= 1) {
        return new Vector3(intersects[0].point.x, intersects[0].point.y, intersects[0].point.z)
      }

      return null
    }

    device.webglAvailable = () => {
      try {
        let canvas = document.createElement("canvas")
        if (!!window.WebGLRenderingContext && (canvas.getContext("webgl") ||  canvas.getContext("experimental-webgl")))
          return true
        else
          return false
      } catch(e) {
        return false
      }
    }

    let component = new Vue({
      data () {return device}
    })

    Vue.prototype.$device = device
  }
}
